import {Component, OnInit} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {NgTemplateOutlet} from "@angular/common";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NgTemplateOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {

  ngOnInit() {}
}
